<template>
    <div class="float-left">
        Data da ultima atualização: {{ this.dataformatada }}
        <b-button
            variant="success"
            :disabled="!desabilitarAtualizarnoRM"
            @click="confirmarAtualizar()"
            >Atualizar no RM
        </b-button>
    </div>
</template>

<script>
import ConveniosServicos from '../../ConveniosServicos'

export default {
    components: {
        parentData: Object,
        desativarBotao: Boolean
    },

    props: {
        convenio: Object
    },

    data() {
        return {
            mostrarDataDaUltimaAtualização: ``,
            mostrarModal: false,
            valor: 0,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            erros: [],
            naturezas: [],
            acoes: [],

            idNaturezaDespesa: null,
            aplicacaoRecurso: {
                idConvenio: 0,
                idAplicacaoRecurso: 0,
                idNaturezaDespesa: null,
                idAcaoConvenio: null,
                codSituacao: null,
                nuValorFinanceiroSebrae: 0,
                nuValorEconomicoSebrae: 0,
                nuValorFinanceiroParceiro: 0,
                nuValorEconomicoParceiro: 0
            }
        }
    },
    computed: {
        desabilitarAtualizarnoRM() {
            if (this.convenio.statusIntegracaoRM == 'S') return true
            else return false
        },
        dataformatada() {
            if (this.convenio.dataDaUltimaAtualizacaoRM != null) {
                const data = new Date(this.convenio.dataDaUltimaAtualizacaoRM)
                const dia = data.getDate()
                const mes = data.getMonth() + 1 // Os meses são indexados a partir de 0
                const ano = data.getFullYear()
                return `${dia
                    .toString()
                    .padStart(2, '0')}/${mes
                    .toString()
                    .padStart(2, '0')}/${ano}`
            } else return 'Não esta integrado ao RM. '
        }
    },
    methods: {
        confirmarAtualizar() {
            this.$swal({
                title: 'Confirmar Atualização das Aplicações de Recursos no RM',
                html: `Confirmar a Atualização das Aplicações de Recursos  no RM ?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.atualizarRecursoRM()
                }
            })
        },
        atualizarRecursoRM() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.atualizarValorRecursoRM(
                this.convenio.idConvenio
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.convenio.dataDaUltimaAtualizacaoRM = Date.now()
                        this.$toast.success(
                            'Aplicações de Recursos Atualizadas no RM com sucesso.',
                            'OK',
                            this.$toastConfig.success
                        )
                    } else {
                        this.erros = response.errors
                        this.$toast.error(
                            'Erro ao Atualizar Aplicações de Recursos no RM.',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    }
}
</script>
